import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api/rest-api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ClientCollaboratorOut, ConsultantImageState, ConsultantState, ConsultantStatus } from './rest-api/rest-api';
import { UserService } from './user/user.service';
import { BehaviorSubject, forkJoin, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { isInputError } from '../shared/functions';

@Injectable({
  providedIn: 'root'
})
export class ClientConsultService {
  public clientConsult: ConsultantState = { status: ConsultantStatus.BLANK, value: null };
  public clientConsultImage: ConsultantImageState = { status: ConsultantStatus.BLANK, value: null };

  private consultPreloaderSubject = new BehaviorSubject<boolean>(true);
  public preloader$ = this.consultPreloaderSubject.asObservable();

  public constructor(
    private restApiService: RestApiService,
    private sanitizer: DomSanitizer,
    private userService: UserService,
  ) { }

  public updateConsultData(): void {
    if(!this.userService.loggedUser) {
      this.clearConsult();
      return;
    }
    this.consultPreloaderSubject.next(true);

    const neccessaryEditRequests = [
      this.restApiService.getUserConsult().pipe(
        catchError((error) => {
          if(isInputError(error, 404)) {
            this.clientConsult.status = ConsultantStatus.NOT_FOUND;
            this.clientConsult.value = null;
          }
          return of(null);
        })),
      this.restApiService.getUserConsultImage().pipe(
        catchError(() => {
          this.clientConsultImage.status = ConsultantStatus.NOT_FOUND;
          this.clientConsultImage.value = null;
          return of(null);
        })),
    ];

    forkJoin(neccessaryEditRequests).pipe(
      take(1),
      map(([consult, consultImage]) =>
        ({ consult, consultImage } as { consult: ClientCollaboratorOut | null, consultImage: Blob | null })),
    ).subscribe({
        next: (data) => this.handleApiData(data),
    });
  }

  private handleApiData(data: { consult: ClientCollaboratorOut | null, consultImage: Blob | null }): void {
    if(data.consult) {
      this.clientConsult.value = {
        name: (data.consult.name.titleBefore ?? '') + ' ' + data.consult.name.firstName ,
        surname: data.consult.name.lastName + ' ' + (data.consult.name.titleAfter ?? ''),
        phone: data.consult.phone.prefix + data.consult.phone.number,
        email: data.consult.email,
      }
      this.clientConsult.status = ConsultantStatus.LOADED;
    }
    if(data.consultImage) {
      this.clientConsultImage.value = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.consultImage));
      this.clientConsultImage.status = ConsultantStatus.LOADED;
    }

    this.consultPreloaderSubject.next(false);
  }

  public clearConsult(): void {
    this.clientConsult.value = null;
    this.clientConsultImage.value = null;
    this.clientConsult.status = ConsultantStatus.BLANK;
    this.clientConsultImage.status = ConsultantStatus.BLANK;
  }
}
